import React, {Component} from 'react';
import Title from '../base/title';
import RadioGroup from '../base/radiogroup';
import api from '../../utils/api';
import {InfoBox, GoogleMap, Marker, Polygon, StyledMapWithAnInfoBox, Wkt} from '../base/map';
import {helpers} from "../../utils/helpers";

export default class Pumps extends Component {

  constructor(props) {
    super(props);

    let allowedGroups = [helpers.groups.ADMINISTRATOR, helpers.groups.PRICING_STAFF];
    let canEdit = helpers.checkUserGroup(allowedGroups, this.props.user);

    this.state = {
      opened: true,
      loader: ' loader-box',
      flags: [],
      addedFlags: [],
      bocas: [],
      filteredBocas: [],
      data: {},
      polygon: '',
      currentMarker: {},
      loadMap : false,
      canEdit
    };
    this.processData = this.processData.bind(this);
    this.getFlag = this.getFlag.bind(this);
    this.updateView = this.updateView.bind(this);
    this.mapRender = this.mapRender.bind(this);
  }

  mapRender(props) {
    let _self = this;
    if (props.loadMap) {
        let polygon = [];
        if (props.polygon) {
            let wkt = new Wkt.Wkt();
            wkt.read(props.polygon.split(';')[1]);
            wkt.toJson().coordinates[0][0].forEach(cord => {
                polygon.push({lat: cord[1], lng: cord[0]});
            });
        }
        return <GoogleMap defaultOptions={{ styles: props.myStyle }} defaultZoom={8} defaultCenter={{
            lat: props.bocas.length ? parseFloat(props.bocas[0].latitude) : props.center.lat,
            lng: props.bocas.length ? parseFloat(props.bocas[0].longitude) : props.center.lng
        }}>
            {props.polygon && <Polygon path={polygon}/>}
            {props.bocas.map((boca, index) => {
                return <Marker key={index} icon={{url: api.marker(boca.brand.map_marker)}}
                               position={{lat: parseFloat(boca.latitude), lng: parseFloat(boca.longitude)}}
                               onClick={ () => {
                                   _self.setState({currentMarker: boca});
                               } }>
                    {props.currentMarker.id === boca.id && <InfoBox onCloseClick={ () => {
                        _self.setState({currentMarker: {}});
                    } } options={{closeBoxURL: ``, enableEventPropagation: true}}>
                      <div className="info-box">
                        <h2>{boca.brand.name.toLowerCase().includes('shell') ? ('Shell ' + boca.global_code + ' (' + boca.inscription_number + ')') : boca.brand.name + " " + boca.inscription_number}<span
                            onClick={ () => {
                                _self.setState({currentMarker: {}});
                            } }>X</span></h2>
                        <p>{boca.address}</p>
                        <p className="mb-2">{boca.company.cuit}</p>
                          {boca.last_prices && boca.last_prices.map(price => {
                              return <p key={price.product_shortname}>{price.product_shortname} ${price.pvp ? price.pvp : " -"}</p>
                          })}
                      </div>
                    </InfoBox>
                    }
                </Marker>
            })}
        </GoogleMap>
    }
    else {
        return <div></div>
    }
  }

  componentDidMount() {
    this.processData(this.props, this.state);
  }

  processData(props, state, flags) {
    if (flags) {
      let _activeFlags = [];
      let _addedFlags = this.state.addedFlags;
      let _boca = [];

      for (let i = 0; i < flags.length; i++) {
        _activeFlags.push(flags[i].color);
      }

      Object.keys(_addedFlags).forEach(key => {
        _addedFlags[key] = 0;
      });

      this.state.bocas.forEach(boca => {
        if (_activeFlags.indexOf(boca.brand.color) >= 0) {
          _boca.push(boca);
          _addedFlags[boca.brand.color]++;
        }
      });

      this.setState({
        loadMap: true,
        addedFlags: _addedFlags,
        filteredBocas: _boca
      }, function() {
        this.refs.flags.update();
      });

    } else {
      let _boca = [];
      let _flags = [];
      let _addedFlags = {};
      props.data.stations.forEach(station => {
        if (station.brand.name.toLowerCase().indexOf('shell') >= 0) {
          station.brand.color = 'shell';
        } else if (station.brand.name.toLowerCase().indexOf('ypf') >= 0) {
          station.brand.color = 'ypf';
        } else if (station.brand.name.toLowerCase().indexOf('axion') >= 0) {
          station.brand.color = 'axion';
        } else if (station.brand.name.toLowerCase().indexOf('petrobras') >= 0) {
          station.brand.color = 'petrobras';
        } else {
          station.brand.color = 'otras';
        }

        if (!_addedFlags[station.brand.color]) {
          _addedFlags[station.brand.color] = 0;
          _flags.push({ 
            id: station.brand.id, 
            label: station.brand.color.toUpperCase(), 
            color: station.brand.color, 
            active: true 
          })
        }

        _addedFlags[station.brand.color]++;
        _boca.push(station)
      });

      this.setState({
        loadMap: true,
        flags: _flags,
        addedFlags: _addedFlags,
        bocas: _boca,
        filteredBocas: _boca,
        loader: ''
      }, function() {
        this.refs.flags.update();
      });
    }
  }

  updateView() {
      let _self = this;
      this.setState({loadMap : false}, () => {
          this.processData(_self.props, _self.state);
      });
  }

  getFlag(item) {
    let _self = this;
    this.setState({loadMap : false}, () =>{
        return _self.processData(_self.props, _self.state, item);
    })
  }

  render() {
    let _self = this;
    let edit = false;
    let title = 'BOCAS DE LA PROVINCIA';
    if (this.props.hasIcon) {
      edit = {onClick: this.props.click, icon: 'fas fa-pencil-alt', label: 'EDITAR CLUSTER'}
      title = 'BOCAS DEL CLUSTER';
    }
    return <div className="row">
        {this.state.canEdit ?
        <Title isOpen={_self.state.opened} toggle={() => {
            _self.setState({opened: !_self.state.opened}, function () {
                if (_self.state.opened) _self.componentDidMount();
            });
        }} edit={edit} text={title} isGray={true} hasIcon={this.props.hasIcon}/>
            :
          <Title text={title} isGray={true}/>
        }

        {this.state.opened && <div className="row">
          <div className="col s12">
            <div className="row">
              <div className={"pumps" + this.state.loader}>
                <div className="col s5 no-gutter">
                  <RadioGroup ref="flags" text='VER:' items={this.state.flags}  getItem={this.getFlag} />
                  <ul className='pumps-list'>
                    {this.state.filteredBocas.map(boca => {
                      return <li key={boca.id} onClick={() => { if (boca.brand.color !== 'shell') _self.props.showStation(boca); else _self.props.showBoca(boca); }}>
                        <i className={"fas fa-map-marker-alt " + boca.brand.color} />
                        <b>{boca.brand.color === 'shell' ? ('Shell ' + (boca.global_code ? boca.global_code : '')) : boca.inscription_number}</b>
                        <span>{boca.address}</span>
                        <img alt="" src="/static/imgs/angle-right.svg" />
                      </li>
                    })}
                  </ul>
                </div>
                <div className="col s7 no-gutter">
                  <StyledMapWithAnInfoBox currentMarker={this.state.currentMarker} renderMethod={this.mapRender} polygon={this.props.data.polygon} bocas={this.state.filteredBocas} loadMap={this.state.loadMap} />
                </div>
              </div>
            </div>
          </div>
        </div>}
      </div>
  }

}


// WEBPACK FOOTER //
// ./src/containers/analisis/pumps.js